var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28565 1.25L7.28565 16.0812L1.99133 11.54C1.47647 11.0975 0.710251 11.17 0.281606 11.7C-0.148254 12.2312 -0.0778262 13.0187 0.437034 13.4612L7.7228 19.7112C7.77987 19.76 7.84665 19.7837 7.9098 19.82C7.9608 19.85 8.00451 19.8862 8.06037 19.9087C8.20001 19.965 8.34694 19.9987 8.49509 19.9987C8.4963 19.9987 8.49873 20 8.49994 20C8.50116 20 8.50359 19.9987 8.5048 19.9987C8.65295 19.9987 8.79987 19.965 8.93952 19.9087C8.99538 19.8862 9.03909 19.85 9.09009 19.82C9.15323 19.7837 9.22002 19.76 9.27709 19.7112L16.5629 13.4613C16.8506 13.2125 17 12.8575 17 12.5C17 12.2175 16.9077 11.9337 16.7183 11.7C16.2896 11.17 15.5234 11.0975 15.0086 11.54L9.71424 16.0812L9.71424 1.25C9.71424 0.56 9.17023 -3.4225e-07 8.49994 -3.71549e-07C7.82965 -4.00849e-07 7.28565 0.56 7.28565 1.25",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/down-arrow-icon.e36f39d811e8b7ea3af5fcf3d3b100c0.svg";
export { ForwardRef as ReactComponent };